<wf-dialog-content>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <wf-input-autocomplete
      showArrowButton
      isRequired
      formControlName="type"
      [strategy]="listStrategy"
      [label]="'DocumentType' | translate"
      [placeholder]="'DocumentType_Placeholder' | translate"
    />
  </form>
</wf-dialog-content>

<wf-dialog-actions>
  <button
    wui-fill-button
    size="md"
    color="primary"
    [disabled]="form.invalid"
    (click)="submit()"
  >
    {{ 'PEPPOL.ACTIONS.CreateDocument' | translate }}
  </button>
</wf-dialog-actions>
